import { Injectable, inject, signal } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';

/** Open/closed state of the Crystal AI side panel (layout hosts it; bar/Home/page open it). */
@Injectable({ providedIn: 'root' })
export class AiPanelService {
  /**
   * Whether Crystal AI is offered at all: false for guests, and once the API answers 403 (no
   * Employee row). The header bar, the panel and the Home block hide themselves when false.
   */
  readonly available = signal(!isGuest(inject(AuthService)));
  readonly open = signal(false);
  /** Template text waiting to be put in the panel composer (consumed by the panel, then reset). */
  readonly draft = signal<string | null>(null);
  show(): void { this.open.set(true); }
  /** Open the panel with an unsent draft in the composer. */
  showWithDraft(text: string): void { this.draft.set(text); this.open.set(true); }
  hide(): void { this.open.set(false); }
  toggle(): void { this.open.update((o) => !o); }
  /** The API refused this user (403): stop offering the assistant for the rest of the session. */
  markUnavailable(): void { this.open.set(false); this.available.set(false); }
}

/** isUserGuest() dereferences the MSAL account; without one, fall back to the API's 403. */
function isGuest(auth: AuthService): boolean {
  try {
    return !!auth.isUserGuest();
  } catch {
    return false;
  }
}
